import request from '@/utils/request'

export function clearCache() {
  return request({
    url: '/config/clearCache',
    method: 'get'
  })
}

export function fetchConfig() {
  return request({
    url: '/config/index',
    method: 'get'
  })
}

export function setConfig(data) {
  return request({
    url: '/config/setConfig',
    method: 'post',
    data
  })
}

export function getQuotaRemaining() {
  return request({
    url: '/config/getQuotaRemaining',
    method: 'get'
  })
}

export function fetchFaceUsageLogs(params = {}) {
  return request({
    url: '/config/faceUsageLogs',
    method: 'get',
    params
  })
}

export function testMapGeocode(params) {
  return request({
    url: '/config/testMapGeocode',
    method: 'get',
    params
  })
}
